<template>
  <div id="app">
    <el-menu :default-active="$route.path" class="el-menu-vertical-demo menu" router>
      <el-menu-item index="/">首页</el-menu-item>
      <el-menu-item index="/baike">土家族百科</el-menu-item>
      <el-menu-item index="/news">土家族要闻</el-menu-item>
      <el-menu-item index="/video">土家族音画</el-menu-item>
      <el-menu-item index="/achievements">研究成果</el-menu-item>
      <el-menu-item index="/expert">专家库</el-menu-item>
      <el-menu-item index="/us">关于我们</el-menu-item>
    </el-menu>
    <el-dropdown  @command="userMenu" class="login-link">
      <span class="el-dropdown-link">
        <i class="el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="user" v-if="loginName">个人中心</el-dropdown-item>
        <el-dropdown-item command="login" v-if="!loginName">登录</el-dropdown-item>
        <!-- <el-dropdown-item command="register" v-if="!loginName">注册</el-dropdown-item> -->
        <el-dropdown-item divided v-if="loginName" command="logout">退出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
      <!-- 需要被缓存的页面 -->
      <keep-alive>
        <router-view v-if="isRouterAlive && $route.meta.keepAlive" />
      </keep-alive>
      <!-- 不需要被缓存的页面 -->
      <router-view v-if="isRouterAlive && !$route.meta.keepAlive" />
    <div class="footer">
      <p>©2019  湖北人民出版社</p>
      <p>地址：湖北省武汉市雄楚大街268号湖北出版文化城     联系电话：027-87679624</p>
    </div>
    <!-- 登录 -->
    <el-dialog :visible.sync="loginVisible" width="50rem" :lock-scroll="false" @open="openLoginDialog" @close="closeLoginDialog">
      <iframe :src="loginIframe" class="login-iframe"></iframe>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
      transitionName:'',
      loginName: false,
      isRouterAlive: true,
      loginVisible: false,
      loginIframe: '',
    }
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  watch: {//使用watch 监听$router的变化
    $route(to, from) {
      // 检查是否登录
      this.loginName = $cookies.get(this.$loginName)

      // 检查是否需要显示登录的popup
      if(this.$showLogin) {
        this.loginVisible = true
        this.$showLogin = false
      }

      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if(to.meta.index > from.meta.index){
	    //设置动画名称
        this.transitionName = 'slide-left';
      }else{
        this.transitionName = 'slide-right';
      }
    }
  },
  /**
   * 用户信息菜单
   */
  methods: {
    /**
     * 点击用户菜单
     */
    userMenu (command) {
      // 检查是否登录
      this.loginName = $cookies.get(this.$loginName)
      if (this.loginName) {
        // 已登录
        if(command == 'logout') {
          // 清除cookie 退出登录
          $cookies.remove(this.$loginName, '/', this.$domain)
          $cookies.remove(this.$loginCode, '/', this.$domain)
          var iframe = document.createElement('iframe'); 
          iframe.src=this.$hcpmUrl + this.$hcpmLogout
          // iframe.style = "display:none";
          document.body.appendChild(iframe);
          this.loginName = false
          this.$router.push({path: '/'})
          // var img = new Image(1, 1);
          // img.src = this.$hcpmUrl + this.$hcpmLogout
          // 如果当前页面为首页，则刷新页面
          // if (this.$route.path == '/') {
          //   // 刷新页面
          //   location.reload()
          // } else {
          //   this.$router.push({path: '/'})
          // }
        } else {
          // 个人中心
          this.$router.push({path: '/user/member'})
        } 
      } else if (command == 'login') {
        // 登录 显示popup
        //this.loginVisible = true

        // this.$router.push({path: '/login'})
        window.location.href = this.$hcpmUrl + this.$hcpmLogin
      }
      // 未登录
      // if (command == 'register') {
      //   // 注册
      //   this.$router.push({path: '/register'})
      // }
      // 重新加载页面
      this.reload()
    },

    /**
     * 打开登录dialog
     */
    openLoginDialog() {
      this.loginIframe = this.$hcpmUrl + this.$hcpmLogin
    },

    /**
     * 关闭登录dialog
     */
    closeLoginDialog() {
      this.loginIframe = ''
    },

    /**
     * 重新加载
     */
    reload() {
      // 通过控制子组件的显示/隐藏，来控制页面的重新加载
      this.isRouterAlive = false;
      this.$nextTick(function(){
        this.isRouterAlive = true;
      })
    }
  },
  mounted() {
    // 检查是否登录
    this.loginName = $cookies.get(this.$loginName)
  }
}
</script>

<style>
@import '../static/css/main.css';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.footer{
  text-align: center;
  background: rgba(0,0,0,.8);
  color: #fff;
  padding: 2rem 0;
  font-size: 0.9rem;
}
.footer p{
  line-height: 4rem;
}

/* 用户信息按钮 */
.login-link{
  position: fixed !important;
  right: 3%;
  z-index: 10;
  top: 2rem;
  padding-left: 2rem;
 
}
.login-link:link,.login-link:visited{
  color: #fff;
}
.login-link:hover {
  cursor: pointer;
}
.login-link i {
  background: url(../static/img/icon-user.png) no-repeat;
  background-size: 1.5rem;
  width: 30px;
  height: 30px;
}
.login-link .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #fff;
  color: #9E180F;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all .3s;
  position: absolute;
  width:100%;
  left:0;
}
.slide-right-enter {
  transform: translateX(-100%);
}
.slide-right-leave-active {
  transform: translateX(100%);
}
.slide-left-enter {
  transform: translateX(100%);
}
.slide-left-leave-active {
  transform: translateX(-100%);
}

/* 登录的popup */
.login-iframe {
  border: none;
  width: 100%;
  height: 27rem;
}

</style>



// WEBPACK FOOTER //
// src/App.vue